module.exports = __webpack_public_path__ + "static/img/pic.3ae13b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneService/pic.png
// module id = z3jq
// module chunks = 0